import React, {FC, useEffect, useState} from "react";
import DataGrid, {Column, Pager, Paging, Scrolling, SearchPanel} from "devextreme-react/data-grid";
import axios from "axios";
import {useTypedSelector} from "../reducers";
import { LoadPanel } from "devextreme-react/load-panel";
import { handleError } from "../error/ErrorHandler";
import moment from "moment";

const AccessLog: FC = () => {
    const { site } = useTypedSelector(state => state.profile);
    const [ loading, setLoading ] = useState(true);
    const [ dataSource, setDataSource ] = useState([]);
    const { status } = useTypedSelector(state => state.auth);

    const getDataSource = async () => {
      try {
        const res = await axios.get('/api/log/access/all');
        if(!res.data) return;
        res.data.forEach( (data: any) => {
          data['accessDtm'] = moment(data['accessDtm']).format('YYYY-MM-DD HH:mm:ss');
        })
        setDataSource(res.data);
      } catch(err) {
        handleError(err);
      } finally {
        setLoading(false);
      }
    };

    
    useEffect(() => {
      if(status === 'idle') return;
      getDataSource();
    }, [ status ]);

    return (
        <div className={`log-content-wrapper ${site}`}>
            <div className={'log-content-body'}>
                { loading &&
                    <LoadPanel visible={true} />
                }
                { !loading &&
                    <DataGrid dataSource={dataSource}
                            showColumnLines={false}
                            showRowLines={true}>
                        <SearchPanel visible={true} />
                        <Column dataField={'accessIp'} caption={'접속 IP'} cssClass={'board-content-header text-center'} width={350} />
                        <Column dataField={'accessAgent'} caption={'기기 정보'} cssClass={'board-content-header header-center'} width={500} />
                        <Column dataField={'accessDtm'} caption={'접속 일시'} cssClass={'board-content-header text-center'} width={350} />
                        <Scrolling rowRenderingMode={'virtual'} />
                        <Paging defaultPageSize={10}>
                            <Pager visible={true} />
                        </Paging>
                    </DataGrid>
                }
            </div>
        </div>
    );
}

export default AccessLog;
